// extracted by mini-css-extract-plugin
module.exports = {"block":"block___1aSB6","picWrap":"picWrap___3wX0Y","pic":"pic___2fg0B","score":"score___NIBbn","airport":"airport___2h3Ce","terminal":"terminal___1rSfn","type":"type___2tkur"};